/**
 * 将数据包按固定宽度分行，并在每行 HEX 数据下方显示零基 byte 索引。
 * byte 索引使用十进制，协议中的 byte28 对应数组 data[28]。
 */
export function formatPacketWithByteIndexes(data, bytesPerRow = 16) {
  const bytes =
    data instanceof Uint8Array ? data : new Uint8Array(data || []);
  if (bytes.length === 0) return '(empty)';

  const rowSize = Math.max(1, Number(bytesPerRow) || 16);
  const indexWidth = Math.max(2, String(bytes.length - 1).length);
  const lines = [];

  for (let start = 0; start < bytes.length; start += rowSize) {
    const row = bytes.slice(start, start + rowSize);
    const hex = Array.from(row, (value) =>
      value.toString(16).padStart(2, '0').toUpperCase()
    ).join(' ');
    const indexes = Array.from(row, (_, offset) =>
      String(start + offset).padStart(indexWidth, '0')
    ).join(' ');

    lines.push(`HEX  : ${hex}`);
    lines.push(`BYTE : ${indexes}`);
    if (start + rowSize < bytes.length) lines.push('');
  }

  return lines.join('\n');
}

